import {getDistance} from 'geolib';
import {store} from '../store';
import {getUser} from '../actions/user';
import { getVehicleslist } from '../actions/vehicleslist';

const BANDAR_LENGEH_COORDINATES = {
  latitude: 26.535521,
  longitude: 53.97346,
};

const TEHRAN_COORDINATES = {
  latitude: 35.706574,
  longitude: 51.40431,
};

export const findCity = userCoordinates => {
  if (!userCoordinates?.latitude || !userCoordinates?.longitude) {
    return null;
  }

  const distanceInMetersWithKish = getDistance(
    {latitude: userCoordinates.latitude, longitude: userCoordinates.longitude},
    BANDAR_LENGEH_COORDINATES,
  );

  const distanceInMetersWithTehran = getDistance(
    {latitude: userCoordinates.latitude, longitude: userCoordinates.longitude},
    TEHRAN_COORDINATES,
  );

  const kishDistanceInKm = distanceInMetersWithKish / 1000;
  const tehranDistanceInKm = distanceInMetersWithTehran / 1000;
  console.log('tehranDistanceInKm', tehranDistanceInKm)
  if ( tehranDistanceInKm <= 120 ){
    return 'tehran'
  }

  if (kishDistanceInKm <= 18) {
    // store.dispatch(getVehicleslist({type: 'bicycle'}));
    store.dispatch(
      getUser({
        city: 'kish',
      }),
    );
    return 'kish';
  } else {
    store.dispatch(
      getUser({
        city: '',
      }),
    );
  }
};
